// Translation helper mixin.
// In the standalone app, window._translations is not available (it was injected by Laravel Blade).
// The __() method falls back to returning the key itself, so existing callers won't break.
// Prefer using vue-i18n's $t() for new code.
module.exports = {
  methods: {
    __(key, replace) {
      let translation = key;

      if (replace) {
        Object.entries(replace).forEach(([k, v]) => {
          translation = translation.replace(':' + k, v);
        });
      }

      return translation;
    },
  },
};
